

import LazyHydrate from 'vue-lazy-hydration'

export default {
  components: {
    LazyHydrate,
    'id-homepage-lazy-trusted': () => import('~/components/homepage/lazy/Trusted.vue')
  },
  transition: 'page',
  data () {
    return {
      reviews: [],
      members: {
        peter: {
          name: 'Peter Zvirinsky',
          avatar: '/Peter.png',
          position: 'Co-founder, Visual Communication Expert',
          description: `“My goal is to make infoDiagram nr 1 place to go for presentation graphics.
On daily basis, I create diagrams, supervise the high standards of our content and support our clients.
Also, I run Slide Design trainings which you are most welcome to join.`,
          cite: 'The day gets better after dose of joga and good cappuccino.”'
        },
        izabela: {
          name: 'Izabela Zvirinska',
          avatar: '/Izabela.png',
          position: 'Co-founder, Graphic Designer',
          description: `“The visual quality of our products is an apple in my eye. I track design news and lead the team of our graphic designers.  Hand-drawn illustrations are my speciality you won’t find anywhere else. You may meet me in person as I’m running PowerPoint trainings. `,
          cite: 'The best ideas come when you travel into the nature”'
        },
        marcin: {
          name: 'Marcin Trofimiuk',
          avatar: '/Marcin.jpeg',
          position: 'Co-founder, Full Stack Developer',
          description: `“I aim to make your experience with our website safe and hassle-free.
If you ever struggle with logging in or payment, I have your back.
I'm the only member of the team who can't name the colors, but my technical superpowers overcome it.
`,
          cite: 'Everything starts working when...”'
        },
        barbara: {
          name: 'Barbara Papiór',
          avatar: '/Basia.png',
          position: 'UX / Graphic Designer'
        },
        katarzyna: {
          name: 'Katarzyna Podlejska',
          avatar: '/Katarzyna.jpg',
          position: 'Business Consultant'
        },
        agnieszka: {
          name: 'Agnieszka Wojciechowska',
          avatar: '/Agnieszka.png',
          position: 'Graphic Designer - Business Consultant'
        },
        rosemary: {
          name: 'Rosemary',
          avatar: '/Rosemary.png',
          position: 'Customer Happiness & Marketing'
        }
      }
    }
  },
  async fetch () {
    this.reviews = await this.$backend.reviews.list()
  },
  head () {
    return {
      title: 'infoDiagram - About',
      bodyAttrs: {
        class: 'page-about'
      }
    }
  }
}
